import React from 'react'
import { Box } from '@mui/material'
import DocumentList from '../../../Component/reusable_components/documents_list.js'
import { IMAGE_BASE_PATH_DBRALC } from '../../../Config/Config.js'
import CosAndPosData from '../../../Assets/JSON/AcademicData/CosAndPos/cosandpos.json'

const CoAndPoPage = () => {
  return (
    <DocumentList
      data={CosAndPosData}
      title="Co's & Po's"
      basePath={IMAGE_BASE_PATH_DBRALC}
      navigatePath="/co&po"
      sx={{ mt: 2 }}
    />
  )
}

export default CoAndPoPage
